function getEntranceCost(state, props) {
	return state.entranceCount === props.targetEntranceCount ? 0 : 1e6;
}
export { getEntranceCost };

//# sourceMappingURL=index143.js.map